export default __webpack_public_path__ + "static/media/pdc_meeting_active.2818407f.svg";